module.exports = __webpack_public_path__ + "static/media/Complaints-Procedure.80b1981d.pdf";